'use client';
import React from 'react';
import {HeroSection} from './components/hero-section/hero-section.react-component';
import {Footer} from './components/footer/footer.react-component';
import {Quiz} from '@/features/60dayhustle/components/quiz/quiz.react-component';
import styles from './page.module.scss';
import {BlogModule} from './components/blog-module/blog-module.react-component';
import {PersonalPlanModule} from './components/pp-module/personal-plan-module.react-component';
import {Header} from './components/header/header.react-component';
import {SocialProof} from './components/social-proof/social-proof.react-component';

const LandingPage: React.FC = () => {
    return (
        <main className={styles.wrapper}>
            <div className={'ud-container'}>
                <Header />

                <section className={styles.section}>
                    <HeroSection />
                </section>

                <section className={styles.section} id="subscription">
                    <PersonalPlanModule />
                </section>

                <section className={styles.section} id="tips">
                    <BlogModule />
                </section>

                <section className={styles.section} id="quiz">
                    <Quiz />
                </section>

                <section id="behind-the-scenes">
                    <SocialProof />
                </section>

                <div className={styles.section}>
                    <Footer />
                </div>
            </div>
        </main>
    );
};

export {LandingPage};
